<template>
	<div id="routes">
		<router-view></router-view>
    <whatsapp></whatsapp>
	</div>
</template>

<script>
import store from './store/store';
import Navigation from './components/Navigation.vue';
import Subnavigation from './components/Subnavigation.vue';
import Footer2 from './components/Footer.vue';
import Whatsapp from './components/Whatsapp.vue';
import {
	getAllProducts,
	loginUser,
	addStates,
	getCategories,
	getDisplaySliders,
	getDisplayProjects,
	getUserOrders,
  setFeaturedProducts,
  setSpecialProducts,
  setNewProducts,
} from './store/actions';

export default {
	vuex: {
		actions: {
			getAllProducts,
			loginUser,
			addStates,
			getCategories,
			getDisplaySliders,
			getDisplayProjects,
      setFeaturedProducts,
      setSpecialProducts,
      setNewProducts,
		}
	},

	ready() {
		this.getDisplaySliders();
		this.loginUser();
		this.getAllProducts();
		this.addStates();
		this.getCategories();
		this.getDisplayProjects();
    this.setFeaturedProducts();
    this.setSpecialProducts();
    this.setNewProducts();

		// +function () {
    //   var head = document.getElementsByTagName("head").item(0);
    //   var script = document.createElement("script");

    //   // var src = (document.location.protocol == 'https:'
    //   //     ? 'https://www.formilla.com/scripts/feedback.js'
    //   //     : 'http://www.formilla.com/scripts/feedback.js');

    //   var src = 'https://www.formilla.com/scripts/feedback.js';

    //   script.setAttribute("type", "text/javascript");
    //   script.setAttribute("src", src); script.setAttribute("async", true);

    //   var complete = false;

    //   script.onload = script.onreadystatechange = function () {
    //     if (!complete && (!this.readyState
    //           || this.readyState == 'loaded'
    //           || this.readyState == 'complete')) {
    //       complete = true;
    //       Formilla.guid = '91f704c2-ecef-4c0c-9b7e-2a9facb388e7';
    //       Formilla.loadFormillaChatButton();
    //     }
    //   };

    //   head.appendChild(script);
    // }();
	},

	components: {
		Navigation,
		Subnavigation,
		Footer2,
    Whatsapp,
	},

	store
};
</script>



// WEBPACK FOOTER //
// Routes.vue?2c84f471